import { AppState } from '@store/app.reducer';
import { createSelector } from '@ngrx/store';
import { AppContextState } from '@store/app-context/app-context.reducer';

const featureSelector = ({ appContext }: AppState) => {
  return appContext;
};

export const selectSearchParams = createSelector(
  featureSelector,
  ({ searchValues }: AppContextState) => searchValues,
);
